import React, { Fragment } from 'react';
import { styled } from 'dripsy';
import { View } from 'react-native';
import { observer } from 'mobx-react-lite';

import { Loader } from '../../common/Loader';
import { UploadMedia } from '@models/Posts/UploadMediaModel';
import { IconTouchable } from '../../common/IconTouchable';

const TransparentBackground = styled(View)({
  zIndex: -1,
  position: 'absolute',
  width: '100%',
  height: '100%',
  bg: '$heading800',
  opacity: 0.7,
});

export interface IMediaUploadItemCoverProps {
  item: UploadMedia;
}

export const MediaUploadItemCover =
  observer<IMediaUploadItemCoverProps>(({ item }) => {
    async function retry() {
      try {
        await item.upload.run();
      } catch (error) {
        // Do nothing
      }
    }

    return (
      <Fragment>
        <TransparentBackground />
        {item.upload.inProgress && (
          <Loader color="$background0" size="large" />
        )}
        {item.upload.isError && (
          <IconTouchable
            name="refresh-1"
            color="$background0"
            onPress={retry}
            size={40}
          />
        )}
      </Fragment>
    );
  });
